import React, { Fragment } from 'react';

import cx from 'classnames';

import { useTravelBriefMoreDetails } from 'detailsv2/LandingV2/Page/RightSide/blocks/Overview/TravelBriefTable/ActivitiesCell/MoreDetailsButton/functions';

import { Events } from '../Events';
import { IActivitiesCellPropsPDF } from '../types';
import s from './index.module.css';

/**
 * Renders the activities cell for a trip event.
 * This component is rendered only for PDF.
 *
 * @param {object} tripEvent - The trip event object.
 * @param {array} data - The data array.
 * @param {string} isFlightTable - Whether it is a flight table.
 * @param {string} timeFormat - The time format.
 * @return {JSX.Element} The activities cell JSX element.
 */
export const ActivitiesCell = ({ tripEvent, data, isFlightTable, timeFormat }: IActivitiesCellPropsPDF) => {
  const { detailsConfig } = useTravelBriefMoreDetails({ tripEvent });

  return (
    <div className={cx(s.eventContainer)}>
      <Events tripEvent={tripEvent} isFlightTable={isFlightTable} timeFormat={timeFormat} />
      <div className={cx(s.moreDetails, isFlightTable && s.noPadding)}>
        {detailsConfig(tripEvent.type).map((detail, i) => (
          <Fragment key={i}>{detail}</Fragment>
        ))}
      </div>
      {data.length > 1 && <div className={s.divider} />}
    </div>
  );
};
